import { apiFetch } from './api';

export interface DailyReport {
  dateKey: string;
  intervalCount: number;
  yesCount: number;
  noCount: number;
  productivityRate: number;
  pauseCount: number;
  pausedSeconds: number;
  totalMinutes: number;
}

export interface RollupReport extends DailyReport {
  period: 'week' | 'month' | 'year';
  startDate: string;
  endDate: string;
}

export const getDailyReport = (date: string) =>
  apiFetch<DailyReport>(`/reports/daily?date=${date}`);

export const getRollupReport = (period: RollupReport['period'], startDate: string) =>
  apiFetch<RollupReport>(`/reports/rollup?period=${period}&startDate=${startDate}`);

export const deleteReports = () =>
  apiFetch<{ ok: true }>(`/reports`, { method: 'DELETE' });
